import React from "react";
import { Card } from "antd";

const ProductTipsComponent: React.FC<{ tips: string }> = (props) => {
  const { tips } = props;
  return (
    <Card bordered={false} className="ss-card ss-card__product-tips">
      <h2 className="ss-title">Product Tips</h2>
      <p className="ss-content textarea-text">{tips}</p>
    </Card>
  );
};

export default ProductTipsComponent;
